//字段中文名
let attributes = {
    username: "账号",
    account: "账号",
    oldAccount: "旧账号",
    newAccount: "新账号",
    newCode: '新账号验证码',
    oldCode: '旧账号验证码',
    password: "密码",
    oldPwd: "旧密码",
    newPwd: "新密码",
    confirmPwd: "确认密码",
    code: "验证码",
    email: "邮箱",
    hospitalName: "医院名称",
    hospitalAddress: "医院地址",
    zipCode: "邮编",
    mobile: "手机号码",
    telphone: "电话号码",
    surName: "姓氏",
    givenName: "名字",
    fullName: "姓名",
    provinceArea: "省市区",
    receiveName: "收件人",
    location: "所在地区",
    tax: "税号",
    detailAddress: "详细地址",
    productCate: "矫治器类型",
    terminationReason: "终止原因",
    recipient: '收件人',
    receivePhone: '收件手机',
    fullAddress: "详细地址"

};
export default attributes;



// WEBPACK FOOTER //
// ./src/utils/form-validate/attributes-cn.js